// extracted by mini-css-extract-plugin
export var footer = "_lr-5";
export var fulfillmentInput = "_lr-0";
export var shipDateInput = "_lr-1";
export var shipmentModal = "_lr-2";
export var shipmentModalContent = "_lr-3";
export var tableContainer = "_lr-4";